import edureka_img from '../../image/cert_Logos/edureka_img.png';
import udemy_img from '../../image/cert_Logos/udemy_img.png';

const my_certificates_data = [
  {
    index: 1,
    cert_title_name: 'MERN Stack Internship',
    cert_provider_name: 'Edureka',
    cert_provider_img_link: edureka_img,
    cert_time_stamp: 'Oct 2022',
    back_grd_color: '#e0e0e0',
    cert_pdf_link:
      'https://drive.google.com/file/d/19UkvTFPvHNz52rKzfpU5zbCA2pGhbN-k/view',
  },
  {
    index: 2,
    cert_title_name: 'Master React JS',
    cert_provider_name: 'Udemy',
    cert_provider_img_link: udemy_img,
    cert_time_stamp: 'Jan 2023',
    back_grd_color: '#fff176',
    cert_pdf_link:
      'https://www.cloudskillsboost.google/public_profiles/0c8ad9e4-1f8b-4753-8c8f-fb9719c627bf',
  },
  {
    index: 3,
    cert_title_name: 'Master Javascript ',
    cert_provider_name: 'Unstop (formerly Dare2Compete)',
    cert_provider_img_link: udemy_img,
    cert_time_stamp: 'April 2023',
    back_grd_color: '#d1b7ff',
    cert_pdf_link:
      'https://unstop.com/certificate-preview/67c35fbb-1a5c-484c-8785-d76a994dcaee',
  },
  {
    index: 4,
    cert_title_name: 'React Js + Redux Training',
    cert_provider_name: 'Sololearn',
    cert_provider_img_link: udemy_img,
    cert_time_stamp: 'Aug 2022',
    back_grd_color: '#aaf5ff',
    cert_pdf_link: 'https://www.sololearn.com/Certificate/CT-JSJZPXZA/jpg',
  },
  // {
  //   index: 5,
  //   cert_title_name: 'Node.js Essential Training',
  //   cert_provider_name: 'LinkedIn',
  //   cert_provider_img_link: udemy_img,
  //   cert_time_stamp: 'Nov 2022',
  //   back_grd_color: '#ffd7ca',
  //   cert_pdf_link:
  //     'https://www.linkedin.com/learning/certificates/1a781b2bf83dd22dc88e3abd271fa6784e32f14d5ed4bec0e586373abba2553c',
  // },
  // {
  //   index: 6,
  //   cert_title_name: 'Learning npm the Node Package Manager',
  //   cert_provider_name: 'LinkedIn',
  //   cert_provider_img_link: udemy_img,
  //   cert_time_stamp: 'Nov 2022',
  //   back_grd_color: '#ffd7ca',
  //   cert_pdf_link:
  //     'https://www.linkedin.com/learning/certificates/60a05a0e8051e8d171c3e7e128a677259d104b2817cc7e4ab345bbf89e54a524',
  // },
  // {
  //   index: 7,
  //   cert_title_name: 'Introduction to MongoDB',
  //   cert_provider_name: 'LinkedIn',
  //   cert_provider_img_link: udemy_img,
  //   cert_time_stamp: 'Dec 2022',
  //   back_grd_color: '#ffd7ca',
  //   cert_pdf_link:
  //     'https://www.linkedin.com/learning/certificates/485ee10a52fa494f1238f95d17e70c98daed41db00cd3a9beb2e2aab80fda238',
  // },
];

export default my_certificates_data;
